module.exports = __webpack_public_path__ + "static/group-dc0f9fcd0c2cd45d91c1fa0717b131a9.png";